export default __webpack_public_path__ + "static/media/init.67c476ed.svg";